	<template>
	  <section>
	    <div class="block" v-if="newsDetails">
	   		<div class="block__header">
	   			<h1 class="block__title">{{{newsDetails.Name}}}</h1>
	    	</div>
	    	<div class="block__content block__content--news">
	    		<div class="news-image" v-if="newsDetails">
		  			<img class="" :src="newsDetails.ImagePath" />
		  		</div>
		  		<div class="news-text">
		  			<time class="news-date">{{newsDetails.ItemDate}}</time>	
		  			<p v-if="newsDetails.Paragraphs">{{{newsDetails.Introduction}}}</p>
		  			<p v-for="paragraph in newsDetails.Paragraphs">{{{paragraph.ParagraphText}}}</p>
		  		</div>
	    	</div>	  		
	  </div>
	  </section>
	</template>

	<script>
	import RouteHeader from "../../shared/RouteHeader";

	import { getNewsDetails } from "./NewsActions";

	export default {
	  components: {
	    RouteHeader
	  },
	  vuex: {
	    getters: {
	      newsDetails: state => state.newsDetails
	    },
	    actions: { getNewsDetails }
	  },

	  route: {
	    data ({ to: { params: { id } } }) {
	      this.getNewsDetails(id);
	    }
	  }
	};
	</script>

	<style lang="scss">
	  @import '../../assets/scss/variables.scss';
	  @import '../../assets/scss/mixins.scss';


	  @mixin paragraphs (){
	  		color:#ffffff !important;
	  		font-family:"frutiger", Arial, "Lucida Grande", sans-serif !important;
	  }

	  .block__content--news{
	  	@include clear-fix;
	  }
	  .news-image{
	  	float: right;
			display: table-cell;
			width: 26%;
			padding-bottom: 30px;

			img {
				width: 100%;
			}
	  }

	  .news-text{
	  	padding-bottom: 30px;
	  	color: #fff !important;

	  	*{
	  		background: none !important;
	  		color: #fff !important;
	  		text-align: left !important;
	  	}
	  }

	  .news-image ~ .news-text{
			width: 74%;
			padding-right: 30px;
			box-sizing: border-box;
	  }
</style>


// WEBPACK FOOTER //
// News.vue?709f6993